import { Component, EventEmitter, Output } from '@angular/core'
import { ModalController, NavParams, PopoverController, ViewController } from 'ionic-angular'
import * as moment from 'moment'


export class DateItem {
  isSelected: boolean;
  momentDate: moment.Moment;
  isEnabled: boolean;
  isToday: boolean;
}

@Component({
  selector: 'rdk-date-picker',
  templateUrl: 'rdk-date-picker.html'
})
export class RdkDatePickerComponent {

  @Output()
  public onDateSelected: EventEmitter<DateItem> = new EventEmitter<DateItem>();

  @Output()
  public onCancelled: EventEmitter<any> = new EventEmitter<any>();

  public currentMoment: moment.Moment;
  public daysGroupedByWeek = [];
  public selectedDateItem: DateItem;
  public daysOfMonth: DateItem[];
  public calendarModal: any;
  public isModal: boolean = !window.matchMedia("(min-width: 768px)").matches;
  get dayName(): string {
    return this.currentMoment.format("dddd")[0].toUpperCase() + this.currentMoment.format("dddd").slice(1)
  }
  get monthName(): string {
    return this.currentMoment.format("MMMM")[0].toUpperCase() + this.currentMoment.format("MMMM").slice(1)
  }

  constructor(public modalCtrl: ModalController, public popoverCtrl: PopoverController, public viewCtrl: ViewController, public navParams?: NavParams) {
    this.currentMoment =  (navParams && navParams.get('currentMoment')) ||  moment();
    this.renderCalender();
    this.setTodayAsDefaultSelectedDate();
  }

  ionViewWillEnter() {
    this.isModal = !window.matchMedia("(min-width: 768px)").matches;
  }

  public renderCalender() {
    this.daysOfMonth = this.generateDaysOfMonth(this.currentMoment.year(), this.currentMoment.month() + 1, this.currentMoment.date());
    this.daysGroupedByWeek = this.groupByWeek(this.daysOfMonth);
  }

  public generateDaysOfMonth(year: number, month: number, day: number) {
    let calendarMonth = moment(`${year}-${month}-${day}`, "YYYY-MM-DD");

    let startOfMonth = calendarMonth.clone().startOf("month").day("sunday");
    let endOfMonth = calendarMonth.clone().endOf("month").day("saturday");

    let totalDays = endOfMonth.diff(startOfMonth, "days") + 1;

    let calendarDays: DateItem[] = [];

    for (let i = 0; i < totalDays; i++) {
      let immunableStartOfMonth = startOfMonth.clone();
      const momentDate = immunableStartOfMonth.add(i, "day")

      let dateItem: DateItem = {
        isSelected: false,
        momentDate: momentDate,
        isEnabled: this.isBelongToThisMonth(immunableStartOfMonth, month),
        isToday: momentDate.clone().startOf("day").isSame(moment().startOf("day"), "day")
      };

      calendarDays.push(dateItem);
    }

    return calendarDays;
  }

  public groupByWeek(daysOfMonth: DateItem[]) {

    let groupedDaysOfMonth = new Array<DateItem[]>();

    daysOfMonth.forEach((item, index) => {


      let groupIndex = Math.floor((index / 7));

      groupedDaysOfMonth[groupIndex] = groupedDaysOfMonth[groupIndex] || [];

      groupedDaysOfMonth[groupIndex].push(item);


    });

    return groupedDaysOfMonth;

  }

  public selectDate(day: DateItem) {

    if (!day.isEnabled) return;

    if (this.selectedDateItem && this.selectedDateItem.isSelected) {
      this.selectedDateItem.isSelected = false;
    }

    day.isSelected = true;
    this.selectedDateItem = day;
    this.currentMoment = day.momentDate.clone();

    this.viewCtrl.dismiss(this.selectedDateItem);

  }

  public setTodayAsDefaultSelectedDate() {
    let today = this.currentMoment.startOf("day")
    let foundDates = this.daysOfMonth
      .filter((item: DateItem) => today.isSame(item.momentDate.clone().startOf("day")));

    if (foundDates && foundDates.length > 0) {
      this.selectedDateItem = foundDates[0];
      this.selectedDateItem.isSelected = true;
      // this.selectedDateItem.isToday = true;
    }

  }

  public isBelongToThisMonth(momentDate: moment.Moment, month: number) {

    return momentDate.month() + 1 === month;
  }

  public setMonthBack() {
    this.currentMoment = this.currentMoment.clone().subtract(1, "month");
    this.renderCalender();

  }

  public setMonthForward() {
    this.currentMoment = this.currentMoment.clone().add(1, "month");
    this.renderCalender();
  }

  public setYearBack() {
    this.currentMoment = this.currentMoment.clone().subtract(1, "year");
    this.renderCalender();
  }
  public setYearForward() {
    this.currentMoment = this.currentMoment.clone().add(1, "year");
    this.renderCalender();
  }

  public confirmDateSelection() {
    this.viewCtrl.dismiss(this.selectedDateItem);
  }

  public cancel() {
    this.viewCtrl.dismiss();
  }

  public showCalendar(event: Event) {
    if (this.isModal) {
      this.calendarModal = this.modalCtrl.create(RdkDatePickerComponent, {currentMoment: this.currentMoment});
      this.calendarModal.onDidDismiss( ( data: DateItem ) => {
        if (data) {
          this.onDateSelected.emit(data);
        }
        else {
          this.onCancelled.emit();
        }
      });
      this.calendarModal.present({ev: event});
    } else {
      this.calendarModal = this.popoverCtrl.create(RdkDatePickerComponent, {currentMoment: this.currentMoment}, {cssClass:"myPopover"});
      this.calendarModal.onDidDismiss( ( data: DateItem ) => {
        if (data) {
          this.onDateSelected.emit(data);
        }
        else {
          this.onCancelled.emit();
        }
      });
      this.calendarModal.present({ev: event});
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/rdk-date-picker/rdk-date-picker.ts